/**
 * Determines if a contract status is cancellable.
 * @param status - The status of the contract.
 * @returns True if the contract status is cancellable, false otherwise.
 */
export const isContractStatusCancellable = (status: string) => {
  return status !== 'Cancelled';
};
